import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { LoginContext } from "../../../../services/api/authentication-api";
import "./task-creation-popup.scss";
import "../tasks-comments/shared-modal-header.scss";

const TaskCreationPopup = (props) => {
    const projectID = props?.projectID ?? -1;

    const changePrivilege = (e, isDoc) => {
        if (props.privileges['Task Management'].Add && e.target.value === "/tasks/create/std") {
            if (projectID === -1) {
                props.history.push(e.target.value);
            }
            else {
                props.history.push("/tasks/create/std?project=" + projectID);
            }
		}
        else if (props.privileges['Document Collaboration'].Add) {         
            props.onShowDCTask();
            if(!props.isTelerikGrid) props.onHide();
		}
        else {
            props.onHide();
            props.handlePermissions("You don't have permission to view this page");
		}
	}

    return (
        <Modal className="task-creation-popup" show={props.show} onHide={props.onHide}>            
            <Modal.Header className="header-popup" closeButton>
                <Modal.Title className="text-confirm">Please select the type of task you want to add:</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="left-side">
                    <div className="task-creation-popup-icon standard-task-icon"></div>
                    <Button className="btn-large task-creation-btn" variant="primary" value="/tasks/create/std" 
                        onClick={(e) => {changePrivilege(e, false); props.onHide();}}
                        disabled={!props.privileges?.["Task Management"]?.Add}
                    >
                        Standard Task
                    </Button>
                </div>
                <div className="vertical-line"></div>
                <div className="right-side">
                    <div className="task-creation-popup-icon document-collaboration-icon"></div>
                    <Button className={"btn-large task-creation-btn"} variant="primary" value="/tasks/create/dc" 
                        onClick={(e) => {changePrivilege(e, true);}}
                        disabled={!props.privileges?.["Document Collaboration"]?.Add}
                    >
                        Document Collaboration
                    </Button>                        
                </div>
            </Modal.Body >
        </Modal >
    )
}

TaskCreationPopup.contextType = LoginContext;
export default withRouter(TaskCreationPopup);

TaskCreationPopup.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    projectID: PropTypes.number,
    history: PropTypes.object.isRequired,
    onShowDCTask: PropTypes.func.isRequired,
    isTelerikGrid: PropTypes.bool,
    handlePermissions: PropTypes.func.isRequired,
    privileges: PropTypes.shape({
        "Task Management": PropTypes.shape({
          Add: PropTypes.bool.isRequired,
        }),
        "Document Collaboration": PropTypes.shape({
          Add: PropTypes.bool.isRequired,
        }),
      }).isRequired,
  };
